






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PanelTitle extends Vue {
  @Prop()
  private title!: string;
}
